var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPorGalon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "39px",
    viewBox: "0 0 33 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1/4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1280,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculadora-02c",
    transform: "translate(-628.000000, -469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1/4",
    transform: "translate(618.000000, 449.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    stroke: "#2268D1",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 29,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    stroke: "#2268D1",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 31,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 L22,13.8170732 C22,15.7500698 20.4329966,17.3170732 18.5,17.3170732 L18.5,17.3170732 L17.8,17.3170732 C17.7328394,17.3170732 17.6661207,17.3151815 17.5998942,17.3114487 L17.5998942,17.3114487 L17.6,22.5 C17.6,23.8807119 16.4807119,25 15.1,25 L15.1,25 L14.6,25 C13.2192881,25 12.1,23.8807119 12.1,22.5 L12.1,22.5 L12.0997902,12.472619 C11.2747172,13.4232409 10.0575616,14.0243902 8.7,14.0243902 L8.7,14.0243902 L7.8,14.0243902 C5.31471863,14.0243902 3.3,12.0096716 3.3,9.52439024 L3.302,9.615 L3.15272482,9.62955782 L3.15272482,9.62955782 L3,9.63414634 L2.5,9.63414634 C1.11928813,9.63414634 5.89750471e-13,8.51485822 5.93303184e-13,7.13414634 L5.93303184e-13,7.13414634 L0,0 L22,0 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.999,2 L23,13.8457317 C23,15.6820785 21.5113468,17.1707317 19.675,17.1707317 C19.513407,17.1707317 19.3545064,17.1592044 19.1990756,17.1369271 L19.1990756,17.1369271 L19.2,21.625 C19.2,22.9366763 18.1366763,24 16.825,24 C15.5133237,24 14.45,22.9366763 14.45,21.625 L14.45,21.625 L14.4506202,12.6553696 C13.6669034,13.6243338 12.4683057,14.2439024 11.125,14.2439024 C8.87257043,14.2439024 7.02700109,12.5019267 6.86273353,10.2913335 C6.70531468,10.324191 6.54217443,10.3414634 6.375,10.3414634 C5.06332372,10.3414634 4,9.2781397 4,7.96646341 L4,7.96646341 L4,2 L22.999,2 Z",
    id: "Combined-Shape",
    fill: "#B7DAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,1 L21,13.8170732 C21,14.482517 20.7400462,15.0872665 20.3160573,15.5352051 C19.8925533,15.9826316 19.3055387,16.273996 18.6504243,16.3126529 L18.6504243,16.3126529 L17.8070334,16.3170732 L16.5998729,16.2683092 L16.6,22.5 C16.6,22.8962651 16.4463867,23.2566768 16.1953501,23.5248092 C15.9458738,23.7912751 15.600361,23.9670477 15.2137568,23.9957967 C14.2037349,24 13.8433232,23.8463867 13.5751908,23.5953501 C13.3087249,23.3458738 13.1329523,23.000361 13.1042033,22.6137568 L13.1042033,22.6137568 L13.0997342,9.79490551 L11.3445734,11.817144 C10.7457618,12.5070749 9.88154501,12.9608301 8.91051138,13.0181946 L8.91051138,13.0181946 L7.8,13.0243902 C6.86339732,13.0243902 6.01269427,12.6565317 5.38458035,12.0573338 C4.60672819,11.3152911 4.16971125,10.2186574 4.33460189,9.02641298 L4.33460189,9.02641298 L3.16295445,8.63414634 L2.5,8.63414634 C2.10373493,8.63414634 1.74332325,8.48053306 1.47519085,8.22949646 C1.20872493,7.9800201 1.03295232,7.63450739 1.00420327,7.24790314 L1.00420327,7.24790314 L1,1 L21,1 Z",
    id: "Combined-Shape",
    stroke: "#2268D1",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    stroke: "#2268D1",
    strokeWidth: 2,
    fill: "#F6F6F6",
    x: 1,
    y: 34,
    width: 31,
    height: 4,
    rx: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPorGalon);
export default __webpack_public_path__ + "static/media/ico-por-galon.e06bf1dd.svg";
export { ForwardRef as ReactComponent };